module.exports = __webpack_public_path__ + "housingStatic/img/noPhoto.63de696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noPhoto.png
// module id = nw6m
// module chunks = 2